import { render, staticRenderFns } from "./TeachDetails.vue?vue&type=template&id=b0856edc&"
import script from "./TeachDetails.vue?vue&type=script&lang=js&"
export * from "./TeachDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports